module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_text_en.1790128953909.png";